var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.976 11.484v1.807a1.205 1.205 0 0 1-1.313 1.204 11.9 11.9 0 0 1-5.197-1.848 11.74 11.74 0 0 1-3.612-3.613 11.9 11.9 0 0 1-1.85-5.221 1.204 1.204 0 0 1 1.2-1.313H5.01a1.204 1.204 0 0 1 1.204 1.036c.076.578.218 1.146.422 1.692a1.2 1.2 0 0 1-.271 1.27l-.765.765a9.63 9.63 0 0 0 3.613 3.613l.765-.765a1.2 1.2 0 0 1 1.27-.27 7.7 7.7 0 0 0 1.692.42 1.205 1.205 0 0 1 1.036 1.223"
  })));
};
export default SvgPhone;